import { render, staticRenderFns } from "./focus.vue?vue&type=template&id=13c6db93&scoped=true&"
import script from "./focus.vue?vue&type=script&lang=js&"
export * from "./focus.vue?vue&type=script&lang=js&"
import style0 from "./focus.vue?vue&type=style&index=0&id=13c6db93&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c6db93",
  null
  
)

export default component.exports